import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { AppConfiguration } from 'src/app/model/app-detail.model';
import { User } from 'src/app/model/user.model';
import { AppToken } from 'src/app/shared/constants/app.constant';

@Injectable({
  providedIn: 'root'
})
export class TokenManagerService {
  appConfiguration!: AppConfiguration;
  loginSubject = new Subject();

  public get userDetail(): User {
    return this.getUserDetail();
  }


  public set storeDetails(value: any) {
    this.setLocalStorage(AppToken.StoreDetail, JSON.stringify(value));
  }

  public get storeDetails(): any {
    const data = localStorage.getItem(AppToken.StoreDetail);
    if (data) {
      return JSON.parse(data);
    } else {
      return null;
    }
  }


  constructor() { }

  getToken(): string {
    return localStorage.getItem(AppToken.UserToken);
  }

  setToken(token: string): void {
    localStorage.setItem(AppToken.UserToken, token);
  }

  setLocalStorage(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  getUserDetail(): User {
    const data = localStorage.getItem(AppToken.UserDetail);
    if (data) {
      return JSON.parse(data);
    } else {
      return null;
    }
  }

  isUserLogin(): boolean {
    const data = this.getUserDetail();
    return data ? true : false;
  }

  clearLocalStorage(): void {
    localStorage.clear();
  }

  setUserDetail(user: User): void {
    localStorage.setItem(AppToken.UserDetail, JSON.stringify(user));
  }
}
